import React from "react";
import { bool } from "prop-types";
import cx from "classnames";

const propTypes = {
  /** Clickable list item */
  clickable: bool,
  /** Disabled state */
  isDisabled: bool,
  /** Selected state */
  isSelected: bool,
};

const CLASS_ROOT = "list__item";

const ListItem = ({
  className,
  children,
  clickable,
  isSelected,
  isDisabled,
  ...other
}) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--clickable`]: clickable,
      "is-selected": isSelected,
      "is-disabled": isDisabled,
    },
    className
  );

  return (
    <li className={classes} {...other}>
      {children}
    </li>
  );
};

ListItem.displayName = "ListItem";
ListItem.propTypes = propTypes;

export default ListItem;
